<template>
  <div style="">
    <div v-if="chains.length > 1" style="margin-left: 10px; margin-bottom: 20px">
      切换商户:
      <el-select size="large" v-model="current_chain_id" style="width: 200px; margin-left: 20px" @change="chooseChain">
        <el-option v-for="item in chains" :value="item.chainId" :key="item.chainId" :label="item.name"></el-option>
      </el-select>
    </div>
    <div v-if="items.length == 0 && agents.length > 0">
      <el-card shadow="false" class="box-card" v-for="groupItem in agents" :key="groupItem.title" style="margin-bottom: 40px">
        <!--        <div style="margin-left: 40px; font-size: 16px; margin-bottom: 10px; margin-top: 60px; ">{{-->
        <!--            groupItem.title-->
        <!--          }}-->
        <!--        </div>-->
        <div slot="header" class="clearfix">
          <div style="font-size: 18px">{{ groupItem.title }}</div>
        </div>
        <div class="flex-container">
          <div class="flex-item" v-for="item in groupItem.agents" @click="click(item)">
            <img style="border-radius: 20px" :src="item.avatar" width="60%">
            <div style="text-align: center;margin-top: 10px; font-size: 16px">{{ item.title }}</div>
          </div>
        </div>
      </el-card>
    </div>
    

    <div v-if="items.length >0">
      <page :items="items"></page>
    </div>

    <TextGenerate ref="textGenerate" @checkLogin="checkLogin"></TextGenerate>
    <voice-chat ref="voiceChat"></voice-chat>


  </div>
</template>

<script>
import TextGenerate from './aigc/text_generate2'
import VoiceChat from './aigc/voice_chat_dialog_custom'

import Page from '@/components/Page'


export default {
  name: 'Index',
  data() {
    return {
      agents: [],
      chains: [],
      current_chain_id: 0,
      items:[],
      platform: 0,
    }
  },
  created: function () {

    this.platform = this.$platform

    const flag = this.$route.query.flag;
    console.log(flag)
    if (flag) {
      localStorage.setItem("flag", flag);
    }

    if (this.$route.query.userId) {
      localStorage.setItem("userId", this.$route.query.userId);
    }

    if (this.$route.query.token) {
      localStorage.setItem("token", this.$route.query.token);
    }


    //this.getAgentList();
    const token = localStorage.getItem("token");
    this.login = token != null && token !== "";
    if (this.login) {
      this.getChainOptions();
      //if (this.platform == 1) {
        this.getPage();
      //}
    }
  },
  components: {
    TextGenerate, VoiceChat, Page
  },
  methods: {
    checkLogin: function () {
      console.log('收到login')
      this.$emit("checkLogin");
    },

    getAgentList: function () {
      let t = this;
      this.$get(
        {
          context: t,
          path: '/function/menu/list/',
          params: {},
          success: function (data) {
            t.agents = data;
          }
        }
      )
    },

    getChainOptions: function () {
      let that = this;
      this.$get(
        {
          context: that,
          path: '/chain/options/',
          params: {},
          success: function (data) {
            that.chains = data.chains;
            that.current_chain_id = data.currentChain;
          }
        }
      )
    },


    chooseChain(e) {
      let that = this;
      this.$get(
        {
          context: that,
          path: '/chain/choose/',
          params: {"chain_id": e},
          success: function (data) {
            window.location.href = "/"
          }
        }
      )
    },


    getPage() {
      let t = this;
      t.$get({
        context: t,
        path: '/page/info/',
        params: {
          scene: 2
        },
        success: function(data) {
          console.log(data.items)
          if(data.items.length > 0 ) {
            t.items = data.items;
            
          }else{
            t.getAgentList();
          }
        }
      })
    },


    click(item) {
      //console.log(item)
      let token = localStorage.getItem("token");
      if (!token) {
        //this.$emit("checkLogin");
        //return;
      }

      if (item.type === 100) {
        this.$router.push(item.page.includes("?")?item.page+"&return=1":item.page+"?return=1");
      } else {
        if (item.chatMode === 1 || item.chatMode === 2) {
          //this.$refs.textGenerate.show(item.itemId, item.title);
          this.$router.push('/app/agent_use?item_id='+item.itemId)
        }else if (item.chatMode === 20 || item.chatMode === 22) {
          this.$refs.voiceChat.show(item.itemId, item.title);
        }else{
          this.$message('暂不支持使用')
        }
      }
    }
  }
}

</script>
<style scoped>
.flex-container {
  display: flex;
  flex-wrap: wrap; /* 关键属性：允许自动换行 */
  gap: 10px; /* 可选：设置项目之间的间距 */
}

.flex-item {
  flex: 1 1 auto; /* 项目可以伸缩 */
  min-width: 150px; /* 设置最小宽度，防止项目过小 */
  max-width: 150px;
  padding: 10px;
  box-sizing: border-box;
  text-align: center;
}
</style>
